//
//
//
//
//
//
//
//
//
//
//
import downAddress from "./downAddress";
import officePackage from "./officePackage";
export default {
  name: "downloadAddress",
  components: {
    downAddress: downAddress,
    officePackage: officePackage
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'downAddress'
    };
  },
  created: function created() {
    this.eventId = this.$route.query.eventId || sessionStorage.getItem('eventId');
  },
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};